<template>
  <modal 
    name="mfa-confirm-modal-three" 
    :pivotY="0.2"
    :height="'auto'"
    :width="'560px'"
    @opened="opened"
    @before-open="beforeOpen">

    <!-- we are loading the pages right now -->
    <div class="border-b p-4 flex justify-between items-center">
      <div class="text-base text-gray-800">
        Multi-Factor Authentication successfully set up.
      </div>

      <a href="#"
        @click.prevent="$modal.hide('mfa-confirm-modal-three')"
        class="text-grey hover:text-grey-darker">
        <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
          <use xlink:href="/img/feather-sprite.svg#x"/>
        </svg>
      </a>
    </div>
    
    <div class="p-4">

      <div class="text-base">
        Your Multi-Factor Authentication is now set up. Next time you login to
        {{ getAppName }}, you will be presented with an extra login step to type in
        the access code.
      </div>

      <div class="mt-8">
        <SubmitButton :onClick="submit" :loading="loading" label="Got it" :isFullWidth="true" />
      </div>

    </div>
  </modal>
</template>

<script>
  import { EventBus }   from '@/shared/event-bus'
  import SubmitButton   from '@/shared/components/form/SubmitButton'

  export default {

    components : {
      SubmitButton
    },

    data() {
      return {
        loading  : false,
        code     : null,
        codeError: null,
      }
    },

    methods : {

      beforeOpen(event) {
        this.loading   = false
        this.code      = null
        this.codeError = null
      },

      opened(event) {
        
      },

      submit() {
        this.$modal.hide('mfa-confirm-modal-three')
      }
    }
  }
</script>